function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import calc from '../calc/index.js';
import on from '../on/index.js';
import onDebounce from '../ondebounce.js';
import set from '../set.js';
import trigger from '../trigger/index.js';
// a value that takes a place in the URL: 0 and false do, null, undefined and '' don't
var isPart = function isPart(value) {
  return value !== null && value !== undefined && value !== '';
};
function handleHashChange(router) {
  set(router, 'hashPath', window.location.hash, {
    hashEvent: true
  });
}
// a malformed escape (a lone %) stays as it is
function decode(part) {
  try {
    return decodeURIComponent(part);
  } catch (_unused) {
    return part;
  }
}
// '/a//b/' → ['a', 'b']
function splitPath(path) {
  var trimmed = path.replace(/\/+/g, '/').replace(/^\/|\/$/g, '');
  return trimmed ? trimmed.split('/') : [];
}
// the parts up to the first empty one, as a path: ['a', 'b'] → '/a/b/'
function toPath(parts) {
  var nonEmptyParts = [];
  for (var i = 0; i < parts.length; i++) {
    if (isPart(parts[i])) {
      nonEmptyParts.push(encodeURIComponent(parts[i]));
    } else {
      break;
    }
  }
  return nonEmptyParts.length ? "/" + nonEmptyParts.join('/') + "/" : '/';
}
// the same route in any spelling: '/a' and '/a/', '%40' and '@'
var route = function route(path) {
  return splitPath(path).map(decode).join('/');
};
// the hash and history singletons, made and initialized on first use
var singletons = {};
function handlePopStateChange(router) {
  set(router, 'path', window.location.pathname, {
    popEvent: true
  });
}
var Router = /*#__PURE__*/function () {
  function Router(type) {
    this.parts = [];
    this.path = '/';
    this.hashPath = '#!/';
    // the history and hash routers are singletons
    var kind = type === 'hash' || type === 'history' ? type : undefined;
    var singleton = kind && singletons[kind];
    if (singleton) {
      // biome-ignore lint/correctness/noConstructorReturn: new Router('hash') gives Router.hash
      return singleton;
    }
    this.type = type;
    if (kind) {
      singletons[kind] = this;
      // a singleton reads the URL as soon as it exists, so it can be bound like any object
      this.init();
    }
  }
  var _proto = Router.prototype;
  _proto.init = function init() {
    var _this = this;
    if (this.initialized) {
      return this;
    }
    var type = this.type;
    calc(this, {
      parts: {
        source: 'path',
        handler: function handler(path) {
          return splitPath(path).map(decode);
        }
      },
      path: {
        source: 'parts',
        handler: toPath
      }
    }, {
      debounceCalc: false
    });
    calc(this, {
      hashPath: {
        source: 'path',
        handler: function handler(path) {
          return path && path !== '/' ? "#!" + path : '';
        }
      },
      path: {
        source: 'hashPath',
        handler: function handler(hashPath) {
          // a plain anchor such as #top is not a route
          return (hashPath == null ? void 0 : hashPath.slice(0, 2)) === '#!' ? hashPath.slice(2) : '';
        }
      }
    }, {
      debounceCalc: false
    });
    on(this, 'change:parts', function (evt) {
      var value = evt.value,
        previousValue = evt.previousValue;
      var equals = value.length === previousValue.length;
      if (equals) {
        for (var i = 0; i < value.length; i++) {
          if (value[i] !== previousValue[i]) {
            equals = false;
            break;
          }
        }
      }
      if (!equals) {
        trigger(_this, 'pathchange');
      }
    });
    if (typeof window !== 'undefined') {
      var _window = window,
        history = _window.history,
        location = _window.location;
      if (type === 'hash') {
        handleHashChange(this);
        window.addEventListener('hashchange', function () {
          return handleHashChange(_this);
        });
        onDebounce(this, 'change:hashPath', function (evt) {
          var isRoute = location.hash.slice(0, 2) === '#!';
          // an empty route leaves a plain anchor such as #top alone
          if (evt != null && evt.hashEvent || !_this.hashPath && !isRoute) {
            return;
          }
          // the same route in another spelling (#!/foo for #!/foo/, %40 for @) is rewritten in place, with no history entry
          if (isRoute && route(location.hash.slice(2)) === route(_this.path)) {
            history.replaceState(history.state, '', _this.hashPath || "" + location.pathname + location.search);
          } else if (_this.hashPath) {
            location.hash = _this.hashPath;
          } else {
            // location.hash = '' would leave a bare '#'; pushState fires no hashchange, and the router already holds the new route
            history.pushState(history.state, '', "" + location.pathname + location.search);
          }
        });
      } else if (type === 'history') {
        // the pathname the router last read or wrote
        var pathname = location.pathname;
        handlePopStateChange(this);
        // any entry counts, the first page load included; a hash change keeps the pathname and is skipped
        window.addEventListener('popstate', function () {
          if (location.pathname !== pathname) {
            pathname = location.pathname;
            handlePopStateChange(_this);
          }
        });
        onDebounce(this, 'change:path', function (evt) {
          if (evt != null && evt.popEvent) {
            return;
          }
          // the route the URL already shows adds no entry; another spelling of it (/a for /a/) is rewritten in place
          if (route(location.pathname) === route(_this.path)) {
            var canonical = toPath(splitPath(_this.path).map(decode));
            if (location.pathname !== canonical) {
              history.replaceState(history.state, '', canonical + location.search + location.hash);
            }
          } else {
            history.pushState(null, '', _this.path + location.search + location.hash);
          }
          pathname = location.pathname;
        });
      }
    }
    this.initialized = true;
    return this;
  };
  _proto.subscribe = function subscribe(obj, route) {
    var _this2 = this;
    var keys = splitPath(route);
    var changeEvents = [];
    var filteredKeys = keys.filter(function (key) {
      return key !== '*';
    });
    var parts = [];
    this.init();
    // the properties after an empty part get null: the URL can't show them
    var resetAfter = function resetAfter(index) {
      for (var i = index + 1; i < keys.length; i++) {
        if (keys[i] !== '*' && isPart(obj[keys[i]])) {
          set(obj, keys[i], null, {
            routeSilent: true
          });
        }
      }
    };
    for (var i = 0; i < filteredKeys.length; i++) {
      var key = filteredKeys[i];
      changeEvents.push("change:" + key);
    }
    on(obj, changeEvents, function (evt) {
      if (evt != null && evt.routeSilent) {
        return;
      }
      var values = [];
      for (var _i = 0; _i < keys.length; _i++) {
        var value = keys[_i] === '*' ? _this2.parts[_i] : obj[keys[_i]];
        if (isPart(value)) {
          values.push(value);
        } else {
          break;
        }
      }
      // a change:key triggered by hand has no event object
      if (evt && !isPart(evt.value)) {
        resetAfter(keys.indexOf(evt.key));
      }
      _this2.parts = values;
    });
    for (var _i2 = 0; _i2 < keys.length; _i2++) {
      var value = keys[_i2] === '*' || !isPart(obj[keys[_i2]]) ? this.parts[_i2] : obj[keys[_i2]];
      if (!isPart(value)) {
        break;
      }
      parts.push(value);
    }
    // the parts after this route stay in the URL
    if (parts.length === keys.length) {
      parts.push.apply(parts, this.parts.slice(keys.length));
    } else {
      resetAfter(parts.length);
    }
    for (var _i3 = 0; _i3 < keys.length; _i3++) {
      if (!isPart(obj[keys[_i3]]) && this.parts[_i3] && keys[_i3] !== '*') {
        set(obj, keys[_i3], this.parts[_i3], {
          routeSilent: true
        });
      }
    }
    on(this, 'pathchange', function () {
      for (var _i4 = 0; _i4 < keys.length; _i4++) {
        // a value the URL already shows keeps its type (0 stays a number)
        var part = _this2.parts[_i4];
        if (keys[_i4] !== '*' && !(isPart(obj[keys[_i4]]) && isPart(part) && String(obj[keys[_i4]]) === String(part))) {
          set(obj, keys[_i4], isPart(part) ? part : null, {
            routeSilent: true
          });
        }
      }
    });
    this.parts = parts;
    return this;
  };
  return _createClass(Router);
}(); // a page that loads the library but never uses the router gets no listener
var _loop = function _loop() {
  var type = _ref2[_i6];
  Object.defineProperty(Router, type, {
    configurable: true,
    enumerable: true,
    get: function get() {
      return singletons[type] || new Router(type);
    }
  });
};
for (var _i6 = 0, _ref2 = ['hash', 'history']; _i6 < _ref2.length; _i6++) {
  _loop();
} // dist/ assigns class methods (Babel's setClassMethods): as in a native class, a for-in doesn't list them
var methods = Object.getOwnPropertyNames(Router.prototype);
for (var i = 0; i < methods.length; i++) {
  Object.defineProperty(Router.prototype, methods[i], {
    enumerable: false
  });
}
export default Router;